import { safeSessionStorage } from "~/lib/utils/safe-storage";

// Per-tab marker of the shopper whose forced MuleSoft refresh has already been
// attempted this login (COM-674).
//
// Client-side cap only. A server-side once-per-login flag (APP_SESSIONS) would
// also cover new tabs and SFRA-side logouts, but KV's 1 write/s per key limit
// and the release window put it out of scope — follow-up.
const ATTEMPTED_FOR_KEY = "hec_tpaBalanceRefreshedFor";

// Fallback for blocked storage (privacy mode), where every read is null. Caps
// forced calls within one page lifetime (client navigations, basket reloads);
// a full page load with blocked storage forces once more — the server-side
// once-per-login follow-up covers that. One entry: only the current shopper
// matters.
let attemptedForInMemory: string | null = null;

export function readRefreshAttempt(): string | null {
  return safeSessionStorage.getItem(ATTEMPTED_FOR_KEY) ?? attemptedForInMemory;
}

export function writeRefreshAttempt(shopperId: string): void {
  attemptedForInMemory = shopperId;
  safeSessionStorage.setItem(ATTEMPTED_FOR_KEY, shopperId);
}

/** Re-arm the forced refresh for whoever logs in next in this tab. */
export function clearRefreshAttempt(): void {
  attemptedForInMemory = null;
  safeSessionStorage.removeItem(ATTEMPTED_FOR_KEY);
}
